"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getActionCreators = getActionCreators;

var _invariant = _interopRequireDefault(require("invariant"));

var _valueLists = require("../reducers/value-lists");

/**
 * Returns all value list action creators
 * @param  {string} type
 * @param  {Object} config
 * @return {Object}
 */
function getActionCreators(type, config) {
  var api = config.api;
  return {
    fetch: {
      request: function request() {
        (0, _invariant.default)(api && api.fetch, 'Please define a fetch function for this model in the config, e.g.\n\n' + ' const config = {\n' + '   valueLists: {\n' + '     api: {\n' + "       fetch: (type) => axios.get('/list')\n" + '     }\n' + '    }\n' + ' }');
        return api.fetch(type);
      },
      reduce: {
        initial: _valueLists.listLoading,
        success: _valueLists.listSuccess,
        failure: _valueLists.listError
      }
    }
  };
}